import type {BaseModel} from '../Base/Base.model';

export abstract class QuestionModel {
  public id: string;
  public isRequired: boolean;
  public title: string;
  public type: QuestionModel.Type;

  protected constructor(props: QuestionModel.Props) {
    this.id = props.id;
    this.title = props.title;
    this.type = props.type;
    this.isRequired = props.isRequired;
  }
}

export namespace QuestionModel {
  export type Props = BaseModel.ModelToProps<QuestionModel>;

  export type Type =
    | 'checkboxes'
    | 'long_text'
    | 'multiple_choice'
    | 'short_text';
}
